import { Component } from '@angular/core';

@Component({
  selector: 'app-empty',
  imports: [],
  templateUrl: './empty.html',
  styleUrl: './empty.css'
})
export class Empty {

}
